import * as React from 'react'
import { translateCountryName}  from "@ui-seeker/utils"
import { Box } from "@mui/material";

import { LabelCountry, NotAllowedBlock } from "@components"


export default function sellerCountryColumn() {
    return [{
        name: 'sellerCountry', label: 'Seller Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    }, {
        name: 'sellerCountry', label: 'Seller Country',
        options: {
            headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value) => {
                return <Box>
                    {!!value && <LabelCountry country={value} label={translateCountryName(value)}/>}
                    {!value && <NotAllowedBlock/>}
                </Box>
            }
        }
    }]
}